import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCraftsman = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.3334 11.8437C13.9117 11.8437 16 9.64121 16 6.92186C16 4.20254 13.9117 2 11.3334 2C8.75501 2 6.66667 4.20254 6.66667 6.92186C6.66667 9.64121 8.75501 11.8437 11.3334 11.8437ZM11.3334 14.3047C8.21835 14.3047 2 15.9535 2 19.2265V21.6875H12.2698C11.6742 20.6016 11.3334 19.3408 11.3334 17.9961C11.3334 16.668 11.6658 15.4219 12.2478 14.3451C11.9222 14.3182 11.6151 14.3047 11.3334 14.3047ZM19.2496 16.2625L15.3714 20.3281C15.2435 20.5068 14.9452 20.5068 14.7748 20.2834L13.7945 19.2559C13.6241 19.0771 13.6241 18.8091 13.7945 18.6304L17.6728 14.5647C17.2892 13.5371 17.5023 12.3308 18.312 11.482C19.1644 10.5884 20.4429 10.365 21.4657 10.9012L19.6332 12.867L20.9117 14.2073L22.7442 12.2862C23.213 13.3584 23.0426 14.6988 22.1902 15.5923C21.3805 16.4412 20.2298 16.6646 19.2496 16.2625Z",
		fill: "currentColor",
		fillOpacity: .87
	})
});
export default SvgIconCraftsman;
